import "@/App.css";
import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WelcomePopup } from "@/components/WelcomePopup";
import { FloatingCta } from "@/components/FloatingCta";
import { LanguageProvider } from "@/lib/LanguageContext";
import { dictionaries } from "@/lib/dictionaries";

import Accueil from "@/pages/Accueil";
import APropos from "@/pages/APropos";
import Vision from "@/pages/Vision";
import Offres from "@/pages/Offres";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import ServiceDetail from "@/pages/ServiceDetail";
import OffresCategory from "@/pages/OffresCategory";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempt < 10) {
          setTimeout(() => tryScroll(attempt + 1), 80);
        }
      };
      tryScroll();
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
};

const Layout = () => {
  const { pathname } = useLocation();
  const footerVariant = pathname === "/a-propos" ? "contact" : "default";
  return (
    <>
      <ScrollManager />
      <Navbar />
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/a-propos" element={<APropos />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/offres" element={<Offres />} />
        <Route path="/offres/:category" element={<OffresCategory />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service/:slug" element={<ServiceDetail />} />
        <Route path="/legal/:slug" element={<Legal />} />
      </Routes>
      <Footer variant={footerVariant} />
      <WelcomePopup />
      <FloatingCta />
    </>
  );
};

const TOAST_OPTIONS = {
  style: {
    background: "#1A1528",
    color: "#fff",
    border: "1px solid #6B5CE7",
  },
};

function App() {
  return (
    <div className="App">
      <LanguageProvider dictionaries={dictionaries}>
        <BrowserRouter>
          <Layout />
          <Toaster position="bottom-right" toastOptions={TOAST_OPTIONS} />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
